/**
 * Decodes the payload segment of a JWT into an object. Returns `null` for
 * any input that isn't a parseable JWT.
 *
 * JWT segments are base64url (RFC 7515 §2): `-` and `_` replace `+` and `/`,
 * and padding is omitted. `atob` only accepts standard base64, so we
 * normalize the alphabet and re-pad before decoding — otherwise legitimate
 * tokens whose payload happens to contain `-` or `_` would fail to parse.
 */
export const parseJwt = (token: string) => {
  try {
    const segment = token.split('.')[1];
    const base64 = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
};
